import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-despinasse-page',
  templateUrl: './despinasse-page.component.html',
  styleUrls: ['./despinasse-page.component.scss']
})
export class DespinassePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
